module.exports = __webpack_public_path__ + "static/CottonOn_GemWebBanner_HeaderImage_V2-098d22977a94fa899633c1f574917523.jpg";